var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNmh)?_c('img',{attrs:{"src":require("@/assets/images/logo.svg"),"alt":"nmh"}}):_c('img',{attrs:{"src":require("@/assets/images/logo-agentik.png"),"alt":"agentik"}})}
var staticRenderFns = []

export { render, staticRenderFns }